import { Component, Input } from '@angular/core';
import { ValidateKycApplicationResponseDto } from '../../../../_core/_model/compliance';

@Component({
  selector: 'app-compliance-validate-step',
  standalone: false,
  templateUrl: './compliance-validate-step.html'
})
export class ComplianceValidateStep {
  @Input() validationResult: ValidateKycApplicationResponseDto | null = null;
}